import { EventLabel } from "shared/components/EventLabel";
import { ExternalIcon } from "shared/components/Icons";
import { formatDatePreview } from "shared/utils/formatDate";
import { SiteLink } from "shared/components/SiteLink";
import { SrcSet } from "shared/components/SrcSet";
import { translate } from "shared/utils/translate";
import { useAppContext } from "shared/utils/useAppContext";
import { useRouter } from "next/router";
import cx from "classnames";
import styles from "./Card.module.css";

export const Card = ({
  date,
  description,
  endDate,
  featured,
  href,
  type,
  resourceTypes,
  src,
  title,
  scope,
  publishedAt,
  buttonLabel,
}) => {
  const { locale } = useRouter();
  const currentScope = useAppContext().scope;

  const isOutOfScope =
    scope &&
    ((currentScope === "Ineo" && !scope.ineo) ||
      (currentScope === "Clariah" && !scope.clariah));

  const label =
    type && type.indexOf(".page") === -1
      ? translate(type.toUpperCase(), locale)
      : null;

  return (
    <SiteLink
      className={cx(styles.container, { [styles.featured]: featured })}
      href={href}
      type={type}
      isOutOfScope={isOutOfScope}
    >
      {(label || resourceTypes || src) && (
        <div className={styles.imageContainer}>
          {label &&
            (type.indexOf(".event") > -1 ? (
              <EventLabel
                startDate={date && formatDatePreview(date, locale)}
                endDate={endDate && formatDatePreview(endDate, locale)}
              />
            ) : (
              <div className={styles.label}>{label}</div>
            ))}
          {resourceTypes && (
            <ul className={styles.resourceTypeList}>
              {resourceTypes.map(
                ({ title: resourceTypeTitle, color }, index) => (
                  <li key={index}>
                    <span
                      className={styles.resourceType}
                      style={{ backgroundColor: color }}
                    >
                      {resourceTypeTitle}
                    </span>
                  </li>
                )
              )}
            </ul>
          )}
          {src && (
            <SrcSet
              alt={title}
              src={src}
              sizes={[
                { minWidth: 1024, width: featured ? 870 : 420, ratio: 16 / 9 },
                { minWidth: 900, width: 300, ratio: 16 / 9 },
                { minWidth: 768, width: 265, ratio: 16 / 9 },
                { minWidth: 700, width: 768, ratio: 16 / 9 },
                { minWidth: 600, width: 660, ratio: 16 / 9 },
                { minWidth: 500, width: 560, ratio: 16 / 9 },
                { minWidth: 400, width: 460, ratio: 16 / 9 },
                { minWidth: 345, width: 360, ratio: 16 / 9 },
                { minWidth: 1, width: 345, ratio: 16 / 9 },
              ]}
            />
          )}
        </div>
      )}

      <div className={styles.content}>
        {label && <div className={styles.label}>{label}</div>}
        <h2>
          {title} {isOutOfScope && <ExternalIcon />}
        </h2>

        {process.env.NODE_ENV === "development" && publishedAt && (
          <span className={styles.publishedAt}>{publishedAt}</span>
        )}

        {description && (
          <p>
            {description.length > 140
              ? `${description.substring(0, 140)}...`
              : description}
          </p>
        )}
      </div>
      {buttonLabel && <span className={styles.button}>{buttonLabel}</span>}
    </SiteLink>
  );
};
